const DiscountBadge = ({ price, compareAtPrice, optionalClassName }) => {
  const numericPrice = parseFloat(price) || 0;
  const numericCompareAtPrice = parseFloat(compareAtPrice) || 0;

  // Only calculate discount if we have valid numeric values
  const discountPercentage =
    numericCompareAtPrice > 0
      ? ((numericCompareAtPrice - numericPrice) / numericCompareAtPrice) * 100
      : 0;
  const roundedDiscount = Math.round(discountPercentage / 10) * 10;

  return (
    <>
      {numericCompareAtPrice > 0 && numericCompareAtPrice > numericPrice && (
        <span
          aria-label={`${roundedDiscount}%`}
          className={`text-body-1 w-fit bg-red px-1.5 py-0.5 !text-[13px] text-white ${optionalClassName}`}
        >
          -{roundedDiscount}%
        </span>
      )}
    </>
  );
};

export default DiscountBadge;
